import { rootApi } from 'root-api'

const api = rootApi.enhanceEndpoints({ addTagTypes: ['GUIDE_SECTIONS'] }).injectEndpoints({
  endpoints: (build) => ({
    getGuideSteps: build.query({
      query: () => ({ url: '/user_guide/guide_steps' }),
      extraOptions: {
        handleErrors: false
      }
    }),
    getUserGuideSteps: build.query({
      query: () => ({ url: '/user_guide/user_guide_steps' }),
      extraOptions: {
        handleErrors: false
      },
      providesTags: ['GUIDE_SECTIONS']
    }),
    upsertUserGuideStep: build.mutation({
      query: ({ identifier, status = 'dismissed', scope = null }) => ({
        url: `/user_guide/user_guide_steps/${identifier}`,
        method: 'patch',
        data: { status, scope }
      }),
      invalidatesTags: ['GUIDE_SECTIONS']
    })
  })
})

export const {
  useGetGuideStepsQuery,
  useGetUserGuideStepsQuery,
  useUpsertUserGuideStepMutation
} = api
